import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import TrailbossFooter from './footer/Footer';
import { msalInstance } from "../../index";

export class LayoutDashboard extends Component {
    static displayName = LayoutDashboard.name;

    constructor(props) {
        super(props);

        this.state = {
            showFooter: false,
            activeAccount: msalInstance.getActiveAccount() != null,
        }

    }
    componentDidMount() {
        this.setState({ showFooter: location.pathname.indexOf("dashboard") > 0 });
    }

    render() {
        return (
            <>
                <div style={{ display: 'none' }}>
                    <NavMenu />
                </div>
                <section id="DashboardWrapper">
                    {this.props.children}
                </section>
                {
                    (this.state.showFooter && this.state.activeAccount) ? <TrailbossFooter /> : ""
                }
            </>
        );
    }
}
